import { supabase } from "@/integrations/supabase/client";

/**
 * Subscription and boost checkout are handled via Paddle directly through
 * `usePaddleCheckout` (see src/hooks/usePaddleCheckout.ts). This adapter
 * only exposes the cancel-subscription helper, which still goes through a
 * server function so it can talk to the Paddle API with the service key.
 */
export const payments = {
  cancelSubscription: async (subscriptionId: string) => {
    const { data, error } = await supabase.functions.invoke(
      "cancel-paddle-subscription",
      { body: { subscription_id: subscriptionId } }
    );
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data;
  },
};

export const PROVIDER = "paddle" as const;